import type { BillingStatus } from "@/types/api";

/** Middle dot separator ? ASCII escape avoids source file encoding issues on Windows. */
const DOT = "\u00B7";

const PLAN_LABELS: Record<string, string> = {
  free: "Free",
  trial: "Trial",
  starter: "Starter",
  pro: "Pro",
};

export type BillingPillVariant = "normal" | "low" | "exhausted";

export interface BillingPillDisplay {
  planLabel: string;
  detail: string;
  variant: BillingPillVariant;
  title: string;
}

export function formatPlanLabel(planId: string | null | undefined): string {
  if (!planId) return "Pro";
  return PLAN_LABELS[planId.toLowerCase()] ?? planId;
}

export function formatVipLabel(vipLevel: string | null | undefined): string {
  if (!vipLevel) return "Starter";
  const key = vipLevel.toLowerCase();
  if (key === "free" || key === "trial") return "Starter";
  return PLAN_LABELS[key] ?? vipLevel;
}

export function getBillingPillDisplay(status: BillingStatus): BillingPillDisplay {
  if (status.subscribed || status.vip_level === "pro" || status.vip_level === "business") {
    const plan = formatVipLabel(status.vip_level);
    return {
      planLabel: plan,
      detail: "Full export",
      variant: "normal",
      title: `${plan} plan ${DOT} pagination and bulk ZIP exports`,
    };
  }
  return {
    planLabel: "Starter",
    detail: "Free",
    variant: "normal",
    title: `Starter ${DOT} downloads and list exports; Bulk Export requires Pro`,
  };
}

/** @deprecated Prefer getBillingPillDisplay + BillingStatusPill for structured UI */
export function formatBillingPillLabel(status: BillingStatus): string {
  const { planLabel, detail } = getBillingPillDisplay(status);
  return `${planLabel} ${DOT} ${detail}`;
}

export function formatExportsQuotaHint(_status: BillingStatus): string | null {
  return null;
}

export const billingTextSeparator = DOT;
